import { render, staticRenderFns } from "./LogOutModal.vue?vue&type=template&id=64cf34d7&"
import script from "./LogOutModal.vue?vue&type=script&lang=ts&"
export * from "./LogOutModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports